<template>

    <div class="columns">
        <div class="column">
        <h1>Vereniging voor het herintroduceren en verder opbouwen van het hondenras "De Belgische Mastiff"</h1>
        </div>

    </div>
</template>

<script>
export default {
    name: "Intro"
}
</script>
<style scoped>
    .logo-section {
        position: fixed;
    }
    .menu {
        /* position: fixed; */
        padding-left: 2vw;
        /* bottom: 1vw; */
    }
    .nav-item {
        display: block;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .menu a {
        margin-bottom: 10px;
        color: #016F70;
        font-size: 1.1em;
        font-weight: 500;
        transition: color .3s ease, border .3s ease;
    }
    .menu a:hover {
        color: #000;
    }

    h1 {
        color: #016F70;
        margin-top: 15px;
        line-height: 1.4;
        font-weight: 400;
        letter-spacing: .5px;
        font-size: 1.7em;
    }
    @media screen and (max-width: 1440px) {
        h1 {
            font-size: 1.4em;
        }
    }

    @media screen and (max-width: 1024px){
        h1{
            font-size: 1.2em;
        }
    }
    @media screen and (max-width: 768px){
        h1{
            font-size: 1.1em;
            margin-bottom: 15px;
        }
    }
</style>
